import React, { Component } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import {
    Loader, Link, Icon
} from '@jutro/components';
import { ButtonLink } from '@jutro/router';
import { isCapabilityEnabled } from 'gw-portals-config-js';

import { withRouter } from 'react-router-dom';
import { GatewayClaimService } from 'gw-capability-ri-claim';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { DatatableUtil } from 'gw-portals-util-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import moment from 'moment';
import styles from './ClaimsFnol.module.scss';
import metadata from './ClaimsFnol.metadata.json5';
import messages from '../../Claims.messages';

const { gatewayParamConfig = {} } = appConfig;

class ClaimsFnol extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        isLoggedIn: PropTypes.bool,
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired,
        intl: PropTypes.func.isRequired,
    };

    state = {
        policyResponse: {},
        isLoading: true,
        currentView: 'online',
        selectedHeaderContent: messages.onlineReportedHeader,
        searchClaimKeyword: undefined,
        claimsData: {},
        docRetrieveIndicator: false,
        isDocLoading: false,
        showClaimNumber: true,
        showContinueButton: false,
        onlineClaimsData: [],
        savedClaimsData: []

    };

    componentDidMount() {
        this.loadInitialData();
    }

    processResponseData = (responseData) => {
        const { intl } = this.props;
        if (!_.isEmpty(responseData)) {
            return responseData.map((claimsInfo) => {
                
                const claims = {
                    fnolid: claimsInfo.id,
                    jurisdictionState: claimsInfo.jurisdictionState,
                    claimNumber: claimsInfo.number,
                    dateOfInjury: intl.formatDate(new Date(claimsInfo.injuryDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                    reportedDate: new Date(claimsInfo.reportedDate).getTime(),
                    lossreported: intl.formatDate(new Date(claimsInfo.reportedDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                    claimantName: this.joinClaimantName(claimsInfo.firstName, claimsInfo.lastName),
                    employerName: claimsInfo.employerName,
                    policyNumber: claimsInfo.policyNumber,
                    locationEventOccurred: claimsInfo.locationEventOccurred,
                    polEffDate: intl.formatDate(new Date(claimsInfo.polEffDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                    pageSaved: claimsInfo.pageSaved
                };
                return claims;
            });
        }
        return [];
    };

    getCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            product: translator(messages.product),
            dateOfLoss: translator(messages.dateOfLoss),
            status: translator(messages.status)
        };

        return (
            <span title={toolTipMessage[property]}>
                {item[property]}
            </span>
        );
    };

    getCurrencyCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            paid: translator(messages.totalPayments),
            netIncurred: translator(messages.totalIncurrednet)
        };
        return (
            <span
                title={toolTipMessage[property]}
                className={styles.riCurrencyField}
            >
                <CurrencyField
                    id={`claimsCurrency_${index}`}
                    value={item[property]}
                    datatype="object"
                    readOnly
                    hideLabel
                />
            </span>
        );
    };

    getLink = (item, index, { id: property }) => {
        const { currentView } = this.state; // Bug list 27.
        const translator = this.context;
        let toolTipMessage = translator(messages.claimNumber);
        if (property === 'policyNumber') {
            toolTipMessage = translator(messages.policyNumber);
            return (
                <Link
                    to={`/ri-policies/${item[property]}/summary`}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }
        if (
            item.status
            === translator({
                id: 'typekey.ClaimState.draft',
                defaultMessage: 'Draft'
            })
        ) {
            const redirectpath = {
                pathname: '/fnol-select-policy',
                state: {
                    claimNumber: item[property],
                    redirectPath: '/ri-claims',
                    claimStatus: item.status
                }
            };
            return (
                <Link
                    to={redirectpath}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }
        const redirectpath = {
            pathname: `/ri-claims-details/${item[property]}`,
            state: {
                claimNumber: item[property],
                redirectPath: `/ri-claims/tile/${currentView}`,
                claimStatus: item.status
            }
        };
        return (
            <Link to={redirectpath} className={styles.gwClaimsLinkContent} title={toolTipMessage}>
                {item[property]}
            </Link>
        );
    };

    downloadFnolPdf = (event) => {
        const { authHeader, isLoading } = this.props;
        this.setState({ isDocLoading: true, docRetrieveIndicator: true });
        const baseUrl = `riclaims/fnol/ph/pdf/${event.fnolid}`;
        GatewayClaimService.getFnolDocument(baseUrl, authHeader).then((r) => r)
            .then(this.showFile).catch(({ error = {} }) => {
                alert(`error getting pdf document :${error}`);
            })
            .finally(() => {
                this.setState({ isDocLoading: false });
            });
    };

    continueClaimLink = (item, index, { id: property }) => {
        const { authHeader, isLoading, currentView } = this.state;
        // this.setState({ isDocLoading: true, docRetrieveIndicator: true });
        const redirectpath = {
            pathname: '/ri-claims-fnol', /* ${item[property]}*/
            state: {
                fnolid: item[property],
                redirectPath: `/ri-claims/tile/${currentView}`,
            }
        };
        return (
            <ButtonLink to={redirectpath} className={styles.ri__ActionColumn__continueButton}>
                Continue
            </ButtonLink>
        );
    };
    //FB 21425 -------
    fileUploadLinkIfClaimNumber = (item, index, { id: property }) => {
        const { currentView } = this.state;
        const claimNumber = item["claimNumber"];
        if (!claimNumber) {
            return null;
        }
        const redirectpath = {
            pathname: `/ri-fileupload`,
            state: {
                clmNo: claimNumber,
                polNo: item["policyNumber"],
                dateOfLoss: item["dateOfInjury"],
                redirectPath: `/ri-claims/tile/${currentView}`,
            }
        };
        return (
            <ButtonLink to={redirectpath} className={styles.ri__ActionColumn__continueButton}>
                Upload Docs
            </ButtonLink>
        );
    };
    //------- FB 21425 

    showFile = (blob) => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([blob], { type: 'application/pdf' });

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = 'fnol.pdf';
        link.click();
        setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    };

    getFormattedDateField = (item, index, property) => {
        const translator = this.context;
        return this.getFormattedDate(item[property.id]);
    };

    getFormattedDate = (date) => {
        const { intl } = this.props;
        return intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
    };

    getmmddyyyyDate = (date) => {
        if (date != nlll) {
            return moment(String(date)).format('MM/DD/YYYY');
        }
        return date;
    };

    getFormattedLocation = (location) => {
        if (location) {
            let replacedString;
            replacedString = value.split('|').join(' ');
            return replacedString;
        }
    }

    joinClaimantName = (firstName, lastName) => {
        return lastName.concat(' ', firstName);
    };

    loadOnlineClaims = async () => {
        const authHeader = {
            Authorization: `Bearer ${this.props.idToken}`
        };
        
        try {
            const response = await GatewayClaimService.getClaimsFnolList(authHeader);
            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(data, (row) => row.reportedDate, ['desc']);
            
            this.setState({
                onlineClaimsData: sortedData,
                selectedHeaderContent: messages.onlineReportedHeader,
                showClaimNumber: true,
                showContinueButton: false
            });
        } catch (error) {
            console.error('Error loading online claims:', error);
            this.setState({ onlineClaimsData: [] });
        }
    };

    loadSavedClaims = async () => {
        const authHeader = {
            Authorization: `Bearer ${this.props.idToken}`
        };
        
        try {
            const response = await GatewayClaimService.getClaimsSavedList(authHeader);
            const data = this.processResponseData(response.claims);
            const sortedData = _.orderBy(data, (row) => row.reportedDate, ['desc']);
            
            this.setState({
                savedClaimsData: sortedData,
                selectedHeaderContent: messages.onlineSavedHeader,
                showClaimNumber: false,
                showContinueButton: true
            });
        } catch (error) {
            console.error('Error loading saved claims:', error);
            this.setState({ savedClaimsData: [] });
        }
    };

    loadInitialData = async () => {
        const {
            location: { state: redirectPath, pathname }
        } = this.props;
        const routePath = pathname && (pathname.trim().split('/') || []);
        const selectedPageFromPath = routePath[routePath.length - 1];
        const activeTile = selectedPageFromPath || redirectPath || 'online';
        
        this.setState({ currentView: activeTile, isLoading: true });
        
        // Load data for the active tab
        if (activeTile === 'online') {
            await this.loadOnlineClaims();
        } else if (activeTile === 'saved') {
            await this.loadSavedClaims();
        }
        
        this.setState({ isLoading: false });
    };

    handleTabChange = async (newView) => {
        const { onlineClaimsData, savedClaimsData } = this.state;
        
        this.setState({ currentView: newView });
        
        // Only load data if not already cached
        if (newView === 'online' && onlineClaimsData.length === 0) {
            this.setState({ isLoading: true });
            await this.loadOnlineClaims();
            this.setState({ isLoading: false });
        } else if (newView === 'saved' && savedClaimsData.length === 0) {
            this.setState({ isLoading: true });
            await this.loadSavedClaims();
            this.setState({ isLoading: false });
        } else {
            // Data already cached, just update the view state
            if (newView === 'online') {
                this.setState({ 
                    selectedHeaderContent: messages.onlineReportedHeader,
                    showClaimNumber: true,
                    showContinueButton: false
                });
            } else if (newView === 'saved') {
                this.setState({ 
                    selectedHeaderContent: messages.onlineSavedHeader,
                    showClaimNumber: false,
                    showContinueButton: true
                });
            }
        }
    };

    handleSearchValueChange = (value) => {
        const { transactionResponse } = this.state;
        this.setState({ searchClaimKeyword: value });
        this.getMappedTransactionData(transactionResponse, {
            searchClaimKeyword: value
        });
    };

    render() {
        const {
            policyResponse,
            isLoading,
            currentView,
            selectedHeaderContent,
            searchClaimKeyword,
            claimsData,
            isDocLoading,
            docRetrieveIndicator,
            showClaimNumber,
            showContinueButton,
            onlineClaimsData,
            savedClaimsData
        } = this.state;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }
        const translator = this.context;
        const tableKey = currentView;

        // Get data for the current view
        let currentData = [];
        if (currentView === 'online') {
            currentData = onlineClaimsData;
        } else if (currentView === 'saved') {
            currentData = savedClaimsData;
        }
        
        const overrides = {
            recentlyViewedTableGrid: {
                data: currentData,
                key: tableKey,
                defaultSorted: [
                    { id: 'dateOfInjuryColumnTitle', desc: false }
                ]
            },
            [currentView]: {
                active: true
            },
            recentlyViewedId: {
                content: translator(selectedHeaderContent)
            },
            searchFilter: {
                value: searchClaimKeyword
            },
            claimNumberColumnTitle: {
                visible: showClaimNumber
            },
            documentview: {
                visible: showClaimNumber
            },
            savedfnolid: {
                visible: !showClaimNumber
            },
            lastPageColumnTitle: {
                visible: !showClaimNumber
            },
            documentLoader: {
                loading: isDocLoading,
                visible: docRetrieveIndicator
            },
            fileUpload: {
                visible: currentView === 'online' //FB 21425
            }
        };

        const resolvers = {
            resolveComponentMap: {},
            resolveCallbackMap: {
                getCell: this.getCell,
                getCurrencyCell: this.getCurrencyCell,
                getLink: this.getLink,
                sortCurrency: DatatableUtil.sortCurrency,
                sortString: DatatableUtil.sortString,
                sortDate: DatatableUtil.sortDate,
                getFormattedDate: this.getFormattedDateField,
                handleSearchValueChange: this.handleSearchValueChange,
                downloadFnolPdf: this.downloadFnolPdf,
                continueClaimLink: this.continueClaimLink,
                fileUploadLink: this.fileUploadLink,
                fileUploadLinkIfClaimNumber: this.fileUploadLinkIfClaimNumber
            },
            resolveClassNameMap: styles
        };

        const policyDetailsData = {
            policyResponse: policyResponse,
            getUpdateCountInfo: this.updateCountInfo,
        };
        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyResponse}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );
    }
}

export default withRouter(withIntl(withAuthenticationContext(ClaimsFnol)));
